import { useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Input } from '../Inputs/Input';
import { Container, Content } from './styles';
import { sendInviteFriendEmail } from '../../controller/EmailController';
import { Button } from '../Buttons/Button';
import { useAlert } from '../../hooks/useAlert';
import { useConfig } from '../../context/configCustom';
import { UserController } from '../../controller/UserController';

export const InviteFriend = () => {
  const location = useLocation();
  const { pathResourceEmail } = useConfig();
  const alert = useAlert();

  const schema = yup.object({
    email: yup.string().email('E-mail inválido').required('E-mail é obrigatório'),
  });

  const {
    control,
    setValue,
    watch,
    handleSubmit,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: { email: '' },
    resolver: yupResolver(schema),
  });

  const data = watch();

  const color =
    location.pathname === '/naturalPersonAccount' || location.pathname === '/legalPersonAccount'
      ? 'background'
      : 'background_white';

  const handleSendInvite = async () => {
    if (!pathResourceEmail) {
      alert.show({ type: 'error', message: 'Erro ao enviar convite' });
      return;
    }
    UserController.insertUserInvite(data.email)
      .then(() => {
        sendInviteFriendEmail({
          to: data.email,
          type: 'inviteFriend',
          pathResource: pathResourceEmail,
        })
          .then(() => {
            alert.show({ type: 'success', message: 'Convite enviado com sucesso' });
            setValue('email', '');
          })
          .catch(() => {
            alert.show({ type: 'error', message: 'Erro ao enviar convite' });
          });
      })
      .catch(() => {
        alert.show({ type: 'error', message: 'Erro ao enviar convite' });
      });
  };

  return (
    <Container color={color} id="invite-friends">
      <Content>
        <p>Convide seu parceiro para fazer parte do Legal Hub Adv</p>
        <div className="input-button">
          <Input
            control={control}
            name="email"
            placeholder="E-mail"
            onChange={(e) => {
              const { value } = e.target;
              setValue('email', value);
              clearErrors('email');
            }}
            error={!!errors.email || false}
            errorText={errors.email?.message || ''}
          />
          <Button
            onClick={handleSubmit(handleSendInvite)}
            text="Enviar convite"
            disabled={!!errors.email || !data.email || data.email === ''}
            dimensions={{ width: '11rem', height: '2.5rem' }}
          />
        </div>
      </Content>
    </Container>
  );
};
